import React from 'react'
import { monthLabel } from './overview'

// ─────────────────────────────────────────────────────────────────────────────
//   El mes de foco — un control para los dos bloques que no son de rango
//
//   Casi todo lo que pinta esta pantalla se agrega sobre el rango, pero dos
//   cosas se niegan a hacerlo y el backend las refuta en vez de aproximarlas:
//
//     · La cascada de reparto. Divide el excedente de UN mes a los porcentajes
//       vigentes, y `AllocationPolicy` está versionada por fecha, así que un
//       rango puede cruzar un cambio y no hay un único reparto por el que
//       dividirlo.
//     · "¿Está registrado este gasto fijo?". Es una pregunta por mes con una
//       respuesta por mes: un cargo pagado en junio y olvidado en julio no está
//       ni registrado ni sin registrar sobre junio-julio.
//
//   Los dos toman el mes de aquí, y por eso el control es UNO y vive arriba con
//   el rango en vez de repetido dentro de cada bloque. Dos controles para un
//   solo estado es cómo se acaba mirando la cascada de un mes y los gastos
//   fijos de otro sin que nada en pantalla lo diga.
//
//   Las opciones salen de `overview.months`, tal cual las devuelve el backend,
//   y no de enumerar el rango aquí: la lista de meses de una ventana la decide
//   `period_range`, y una segunda enumeración en cliente es un sitio donde se
//   puede decidir distinto.
//
//   No se renderiza con un mes suelto. Ahí el foco es ese mes y no hay nada que
//   elegir, así que la pantalla es exactamente la de antes del rango.
// ─────────────────────────────────────────────────────────────────────────────

export default function FocusMonthPicker({ months, value, onChange }) {
  if (!months || months.length < 2) return null

  return (
    <div style={{ minWidth: 200 }}>
      <label className="form-label" htmlFor="cf-focus-month">Month in focus</label>
      <select
        id="cf-focus-month"
        className="select cf-input"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {months.map((m) => <option key={m} value={m}>{monthLabel(m)}</option>)}
      </select>
      <div style={{ fontSize: 11.5, color: 'var(--text-muted)', marginTop: 4, maxWidth: 320, lineHeight: 1.45 }}>
        The surplus cascade and the standing charges are per-month. This is the month of the range
        they show.
      </div>
    </div>
  )
}
